import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import QuickEntryFormModal from '@/components/feature/QuickEntryFormModal';
import type { QuickFormType } from '@/components/feature/QuickEntryForm';
import type { QuickEntryItem } from '@/types/content';

/** 快速入口固定内容（不随后台配置变化） */
const QUICK_ENTRIES: QuickEntryItem[] = [
  { id: 1, icon: 'ri-calendar-event-line', title: '会议培训', desc: '培训会议与学术活动', href: '#activities' },
  { id: 2, icon: 'ri-book-open-line', title: '课程中心', desc: '名医名院精品课程体系', href: '#courses' },
  { id: 3, icon: 'ri-hospital-line', title: '名医名院', desc: '名医名院协同推广', href: '#hospitals' },
  { id: 4, icon: 'ri-heart-pulse-line', title: '优势病种', desc: '专病特色诊疗方案', href: '#diseases' },
  { id: 5, icon: 'ri-links-line', title: '专科联盟', desc: '跨院专科协同共建', href: '#partners' },
  { id: 6, icon: 'ri-line-chart-line', title: '真实世界', desc: '多中心研究发起及入组、相关科研支持', href: '#achievements' },
  { id: 7, icon: 'ri-database-2-line', title: '数据服务', desc: '数据治理开发入表一体化服务', href: '#stats' },
  { id: 8, icon: 'ri-heart-2-line', title: '康养管家', desc: '健康生活数智人管家', href: '#diseases' },
  { id: 9, icon: 'ri-team-line', title: '生态合作', desc: '机构入驻与协同共建', href: '#partners' },
];

const FORM_BY_TITLE: Record<string, QuickFormType> = {
  专科联盟: 'alliance',
  数据服务: 'service',
  生态合作: 'cooperation',
  真实世界: 'realworld',
};

export default function QuickEntry() {
  const [activeForm, setActiveForm] = useState<QuickFormType | null>(null);

  return (
    <section id="quick-entry" className="scroll-mt-24 relative z-20 w-full px-4 md:px-8 -mt-16 md:-mt-20">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-8">
          <SectionHeading
            eyebrow="快速入口"
            title="一键直达平台核心服务"
            description="围绕中西医结合智慧生态，聚合医院优势专科、专病真实世界研究、国医名师数字孪生、全民健康数智化、数据一体化服务六大服务板块。"
          />
          <div className="grid grid-cols-3 gap-2.5 md:gap-4">
            {QUICK_ENTRIES.map((item) => {
              const formType = FORM_BY_TITLE[item.title];
              const cardClass =
                'group flex flex-col items-center text-center gap-2 md:gap-3 p-3 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/60 transition-colors cursor-pointer';
              const inner = (
                <>
                  <span className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${item.icon} text-lg md:text-2xl`}></i>
                  </span>
                  <span className="font-medium text-foreground-900 text-xs md:text-base whitespace-nowrap">
                    {item.title}
                  </span>
                  <span className="hidden sm:block text-xs text-foreground-500 leading-relaxed">{item.desc}</span>
                </>
              );
              return formType ? (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setActiveForm(formType)}
                  className={cardClass}
                >
                  {inner}
                </button>
              ) : (
                <a key={item.id} href={item.href} className={cardClass}>
                  {inner}
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <QuickEntryFormModal type={activeForm} onClose={() => setActiveForm(null)} />
    </section>
  );
}